const DiagnosticTypes = {
    "moons": "moons",
    "moons_advanced": "moons advanced",
    "no_candidato": "no candidato",
    "moons_posible_advanced": "moons posible advanced"
}

export default DiagnosticTypes;